import { useCallback } from 'react';
import { createFileRoute, useRouter } from '@tanstack/react-router';

import { useClubCardQuery } from '@features/club/api/hooks';
import { useClubColors } from '@features/club/hooks/useClubColors';
import { GamePageWidget } from '@features/game/pages/GamePage/GamePageWidget';

export const Route = createFileRoute(
  '/club/$clubId_/tournament/_video/$tournamentId_/game/$gameId',
)({
  component: Page,
});

function Page() {
  const { gameId, clubId, tournamentId } = Route.useParams();
  const { navigate } = useRouter();

  const { data: club } = useClubCardQuery(clubId);

  // перекраска в клубные цвета
  useClubColors(club?.themeColor ?? undefined);

  const handleLeave = useCallback(() => {
    navigate({
      to: '/club/$clubId/tournament/$tournamentId',
      params: { clubId, tournamentId },
      from: '/',
    });
  }, [clubId, navigate, tournamentId]);

  return (
    <GamePageWidget
      key={gameId}
      tournamentId={tournamentId}
      gameId={gameId}
      onLeave={handleLeave}
    />
  );
}
